import { type PdfFocusReturnTarget } from "@/domains/documents/components/pdf/usePdfDialogScroll";
import { useToast } from "@/hooks/use-toast";
import { useAuthStore } from "@/hooks/useAuthStore";
import type { Document } from "@/types/documents";
import { useEffect, useRef, useState } from "react";

export function useTablePreviewState() {
  // Delete confirmation dialog state
  const [deleteConfirmState, setDeleteConfirmState] = useState<{
    open: boolean;
    docId: string | null;
    filename: string | null;
  }>({
    open: false,
    docId: null,
    filename: null,
  });

  // Preview dialog state
  const [previewDocument, setPreviewDocument] = useState<Document | null>(null);
  const [previewBlobUrl, setPreviewBlobUrl] = useState<string | null>(null);
  const [previewBlobData, setPreviewBlobData] = useState<Blob | null>(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const previewReturnFocusRef = useRef<PdfFocusReturnTarget | null>(null);
  const [originalDwgFilePath, setOriginalDwgFilePath] = useState<string | null>(null);
  const { toast } = useToast();
  const authStore = useAuthStore();

  // Cleanup blob URL on unmount or when replaced to prevent memory leaks
  useEffect(() => {
    return () => {
      if (previewBlobUrl) {
        URL.revokeObjectURL(previewBlobUrl);
      }
    };
  }, [previewBlobUrl]);
  return {
    toast,
    authStore,
    setDeleteConfirmState,
    deleteConfirmState,
    previewReturnFocusRef,
    setPreviewBlobUrl,
    setPreviewBlobData,
    setOriginalDwgFilePath,
    setPreviewDocument,
    setPreviewOpen,
    previewDocument,
    previewBlobUrl,
    previewBlobData,
    previewOpen,
    originalDwgFilePath,
  };
}
